import Div100vh from 'react-div-100vh';
import { NavLink, useNavigate, useParams } from 'react-router-dom';
import useFetch from '../../api/useFetch';
import { Box, Typography, useTheme } from '@mui/material';
import { tokens } from '../../global/theme/tokens';
import Cookies from 'universal-cookie';
import { useEffect, useState } from 'react';
import { API_GET, API_GET_NO_TOKEN, DBRequest, useConfig } from '../../api/api';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { SalesObjectPreview } from './SalesObjectPreview';
import AcceptTerms from '../digital-signature/AcceptTerms';
import { useTranslation } from 'react-i18next';
import Loader from '../../components/special/Loader';
import NoDataAnimation from '../../components/animation/NoDataAnimation';

export const SalesObjectCustomerView = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const config = useConfig();
  const { t } = useTranslation();
  const cookies = new Cookies();
  const colorMode = cookies.get('colorMode');

  const navigate = useNavigate();

  const { token } = useParams();

  const [apiData, setApiData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isInvalide, setIsInvalide] = useState(false);

  useEffect(() => {
    DBRequest({
      config,
      method: API_GET_NO_TOKEN,
      path: `sales-objects/external/${token}`,
      onResponse: handleResponse,
      onLoading: setIsLoading,
      onError: () => setIsInvalide(true),
    });
  }, [config]);

  function handleResponse(res) {
    // data
    setApiData(res);
  }

  return (
    <Div100vh>
      <img
        src={
          colorMode === 'dark'
            ? '/assets/uploads/background-dark.webp'
            : '/assets/uploads/background-bright.webp'
        }
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          position: 'absolute',
          top: '0',
          left: '0',
          objectPosition: '32%',
          zIndex: '-5',
        }}
      />
      <Box className="h-full flex flex-col backdrop-blur-md">
        <img
          src={
            colorMode === 'dark'
              ? '/assets/svg/exopaper-text-darkmode.svg'
              : '/assets/svg/exopaper-text.svg'
          }
          className="h-10 lg:absolute top-0 right-5 mr-auto ml-4 mt-5"
        />
        <Loader active={isLoading} />
        {isInvalide ? (
          <Box className="h-full flex justify-center items-center">
            <Box
              sx={{ bgcolor: colors.card }}
              className="px-3 py-2 rounded-lg flex flex-col items-center"
            >
              <NoDataAnimation />
              <Typography variant="h2">
                {t('sales object not found')}
              </Typography>
            </Box>
          </Box>
        ) : (
          <SalesObjectPreview salesObject={apiData?.data} />
        )}
        <Box
          sx={{ bgcolor: colors.glass }}
          className="w-full flex flex-wrap justify-evenly px-4 py-2 bg-slate-200 z-20 rounded-t-lg max-w-[1100px] mx-auto backdrop-blur-md"
        >
          <NavLink to="/privacy-policy">
            <Typography>
              {t('Privacy Policy')} <KeyboardArrowRightIcon className="ml-1" />
            </Typography>
          </NavLink>

          <NavLink to="/terms-of-service">
            <Typography>
              {t('Terms of Service')}
              <KeyboardArrowRightIcon className="ml-1" />
            </Typography>
          </NavLink>
        </Box>
      </Box>
    </Div100vh>
  );
};
